import { FaArrowRight } from "react-icons/fa";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { SiHashnode } from "react-icons/si";
import { useEffect, useState } from "react";
import { request, gql } from "graphql-request";
// Import Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
const HASHNODE_API = "https://gql.hashnode.com/";

// GraphQL query for fetching latest 2 blog posts
const GET_USER_ARTICLES = gql`
  query GetUserArticles($host: String!) {
    publication(host: $host) {
      posts(first: 2) {
        edges {
          node {
            id
            title
            brief
            slug
            coverImage {
              url
            }
            publishedAt
          }
        }
      }
    }
  }
`;

export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://personal-backend-pi.vercel.app/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Server error:', errorData);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Network error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const menuItems = [
    { href: '#about', icon: 'fas fa-user', label: 'About' },
    { href: '#resume', icon: 'fab fa-readme', label: 'Resume' },
    { href: '#services', icon: 'fas fa-cog', label: 'Services' },
    { href: '#portfolio', icon: 'fas fa-briefcase', label: 'Portfolio' },
    { href: '#pricing', icon: 'fas fa-tag', label: 'Pricing' },
    { href: '#contact', icon: 'fas fa-paper-plane', label: 'Contact' }
  ];

  // Client-side refresh for real-time updates using GraphQL
  const refreshBlogs = async () => {
    setIsRefreshing(true);
    try {
      const variables = {
        host: "robocon2025-journey.hashnode.dev"
      };

      const data = await request(HASHNODE_API, GET_USER_ARTICLES, variables);
      if (data?.publication?.posts?.edges) {
        const posts = data.publication.posts.edges.map(edge => edge.node);
        setBlogs(posts);
        console.log('Fetched blogs:', posts); // Debug log
      }
    } catch (error) {
      console.error('Failed to refresh blogs:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  // Fetch blogs on component mount and setup auto-refresh
  useEffect(() => {
    // Initial fetch
    refreshBlogs();

    // Auto-refresh every 5 minutes
    const interval = setInterval(refreshBlogs, 5 * 60 * 1000);

    // Refresh when tab becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        refreshBlogs();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);



  return (
    <div id="wrapper" className={`bg_dark counter-scroll ${isDarkMode ? 'dark' : 'light'}`}>
      {/* Background Video */}
      <video className="body-overlay" muted autoPlay loop playsInline>
        <source src="/assets/video/Dust-Dot-Particles.mp4" type="video/mp4" />
      </video>

      {/* Header */}
      <div className="header header-fixed style-1">
        <div className="tf-container">
          <div className="row">
            <div className="offset-xxl-4 col-xxl-7 offset-xl-4 col-xl-7">
              <div className="header-sidebar style-horizontal bs-light-mode">
                <div className="box">
                  <div className="avatar">
                    <img src="/assets/images/user/me.png" width="68" height="68" alt="avatar" />
                  </div>
                  <div className="info">
                    <h6 className="font-4 mb_4">Dev Bhvua</h6>
                    <div className="text-label text-uppercase fw-6 text_primary-color font-3 letter-spacing-1">
                      Full Stack Developer
                    </div>
                  </div>
                </div>
                <ul className="nav-menu style-2 list-icon">
                  {menuItems.map((item, index) => (
                    <li key={index}>
                      <a className={`nav_link ${index === 0 ? 'active' : ''}`} href={item.href}>
                        <i className={`${item.icon}`}></i>
                        <span className="tooltip text-caption-1">{item.label}</span>
                      </a>
                    </li>
                  ))}
                </ul>
                <button
                  className="menu-button show-menu-mobile link-no-action"
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                  <i className="fas fa-grip"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="popup-menu-mobile" id="menu-1">
            <ul className="nav-menu style-3">
              {menuItems.map((item, index) => (
                <li key={index} className="text-menu text_white">
                  <a href={item.href} className="nav_link toggle splitting link link-no-action text-button font-3 fw-6">
                    <span className="text" data-splitting>{item.label}</span>
                    <span className="text" data-splitting>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="tf-container w-2">
        <div className="row">
          <div className="offset-xxl-4 col-xxl-7 offset-xl-4 col-xl-7">
            <div className="main-content section-onepage">

              {/* User Bar */}
              <div className="user-bar text-center">
                <div className="box-author mb_12">
                  <div className="img-style mb_16">
                    <img src="/assets/images/user/me.png" width="314" height="314" alt="feature post" />
                  </div>
                  <div className="info">
                    <div className="name font-2 text_white mb_8">Dev Bhuva</div>
                    <div className="text-label text-uppercase fw-6 text_primary-color font-3 mb_16 letter-spacing-1">
                      Full Stack Developer
                    </div>
                    <a href="mailto:devbhuva1206@gmail.com" className="hover-underline-link text_white text-body-2 mb_4">
                      devbhuva1206@gmail.com
                    </a>
                    <p className="text-caption-2 text_secondary-color font-3">Based in Ahmedabad, India</p>
                  </div>
                </div>

                <ul className="list-icon d-flex justify-content-center mb_28">
                  <li><a href="https://www.linkedin.com/in/devbhuva" className="fab fa-linkedin" aria-label="LinkedIn"></a></li>
                  <li><a href="https://github.com/DevBhuva/" className="fab fa-github" aria-label="GitHub"></a></li>
                  <li><a href="https://x.com/DevBhuva07" className="fab fa-x" aria-label="X (Twitter)"></a></li>
                  <li><a href="https://hashnode.com/@devbhuva" aria-label="Hashnode"><SiHashnode size={28} /> </a></li>
                </ul>

                <a href="/assets/res.pdf" className="tf-btn btn-w-full style-border mb_20" aria-label="View My CV">
                  <span className="bg_btn"></span>
                  <span className="title"><a href="/assets/res.pdf"><i className="fab fa-readme"></i>View My CV</a></span>
                  <span className="effect-shine"></span>
                </a>

                <a href="#contact" className="tf-btn style-1 animate-hover-btn btn-w-full">
                  <i className="fas fa-envelope"></i><span>Contact Me</span>
                </a>

                <div className="item-shape">
                  <img src="/assets/images/item/small-comet.png" alt="item" />
                </div>
              </div>

              {/* About Section */}
              <div id="about" className="section-about section spacing-1">
                <div className="heading-section mb_45">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_32">
                    About
                  </div>
                  <div className="title-border-shape">
                    <h4 className="animationtext clip">
                      Hello! I'm <span className="tf-text s1 cd-words-wrapper text_primary-color">
                        <span className="item-text is-visible">Full Stack Developer</span>
                        <span className="item-text is-hidden">Ethical Hacker</span>
                        <span className="item-text is-hidden">Freelancer</span>
                      </span>
                    </h4>
                    <div className="shape">
                      <span className="shape-1"></span>
                      <span className="shape-2"></span>
                      <span className="shape-3"></span>
                      <span className="shape-4"></span>
                    </div>
                    <div className="line">
                      <span className="line-horizontal horizontal-1"></span>
                      <span className="line-horizontal horizontal-2"></span>
                      <span className="line-vertical vertical-1"></span>
                      <span className="line-vertical vertical-2"></span>
                    </div>
                  </div>
                </div>
                <h1 className="title mb_16 split-text effect-blur-fade">
                  Empower Code Intelligence
                </h1>
                <p className="text_muted-color font-3 mb_43 split-text split-lines-transform">
                  Hello! I’m Dev Bhuva, a Full-Stack Developer and Ethical Hacker with years of experience in building secure, scalable, and innovative applications. My expertise spans front-end and back-end development, database design, API integration, cybersecurity, and penetration testing.
                </p>
                <div className="wrap-counter tf-grid-layout md-col-3">
                  <div className="counter-item bs-light-mode">
                    <div className="counter-number h2 text_white mb_7">
                      <div className="odometer" data-number="10">3</div>
                      <span className="sub">+</span>
                    </div>
                    <p className="text-body-1 text_muted-color font-3">Years in Full Stack Development</p>
                    <div className="item-shape">
                      <img src="/assets/images/item/small-comet.webp" alt="item" />
                    </div>
                  </div>
                  <div className="counter-item bs-light-mode">
                    <div className="counter-number h2 text_white mb_7">
                      <div className="odometer" data-number="500">30</div>
                      <span className="sub">+</span>
                    </div>
                    <p className="text-body-1 text_muted-color font-3">Satisfied Clients</p>
                    <div className="item-shape">
                      <img src="/assets/images/item/small-comet.webp" alt="item" />
                    </div>
                  </div>
                  <div className="counter-item bs-light-mode">
                    <div className="counter-number h2 text_white mb_7">
                      <div className="odometer" data-number="1">10</div>
                      <span className="sub">+</span>
                    </div>
                    <p className="text-body-1 text_muted-color font-3">Projects Completed</p>
                    <div className="item-shape">
                      <img src="/assets/images/item/small-comet.webp" alt="item" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Resume Section */}
              <div id="resume" className="section-resume spacing-1 section">
                <div className="heading-section mb_44">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_30">
                    Resume
                  </div>
                  <h3 className="text_white fw-5 split-text effect-blur-fade">Education & Experience</h3>
                </div>
                <div className="effect-line-hover">
                  {[
                    { title: 'Dimploma in Information Technology', school: 'LJ Polytechnic', date: '2022 - 2025' },
                    { title: 'Software Development Enginner (SDE)', school: 'BLUESTOCK.in', date: '1 Aug - 30 Aug' },
                    { title: 'B-tech in Cyber Security', school: 'Gandhinagar Institute of Technology', date: '2025 - 2028' }
                  ].map((item, index) => (
                    <div key={index} className="wrap-education-item area-effect scrolling-effect effectTop">
                      <span className="point"></span>
                      <div className="education-item">
                        <div className="content">
                          <h5 className="font-4 mb_4">
                            <a href="#contact" className="link">{item.title}</a>
                          </h5>
                          <span className="text-body-1 font-3">{item.school}</span>
                        </div>
                        <div className="date text-caption-1 text_white font-3">
                          {item.date}
                        </div>
                        <div className="item-shape spotlight">
                          <img src="/assets/images/item/small-comet.webp" alt="item" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Services Section */}
              <div id="services" className="section-service section spacing-1">
                <div className="heading-section mb_43">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_33">
                    Services
                  </div>
                  <h3 className="text_white fw-5 split-text effect-blur-fade">My Specialization</h3>
                </div>
                {[
                  { number: '01', title: 'Full Stack Development', image: 'service-item-1.webp' },
                  { number: '02', title: 'Robotics & IOT', image: 'service-item-2.webp' },
                  { number: '03', title: 'Ethical Hacking', image: 'service-item-3.webp' },
                  { number: '04', title: 'Web Designing', image: 'service-item-4.webp' }
                ].map((service, index) => (
                  <div key={index} className="service-item area-effect scrolling-effect effectBottom">
                    <div className="content-inner d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center content">
                        <span className="number text-label text_muted-color font-3">{service.number}/</span>
                        <h5 className="text_white font-4">
                          <a href="#contact" className="link">{service.title}</a>
                        </h5>
                      </div>
                      <a href="#contact" className="btn-arrow">

                        <FaArrowRight className="text-xl" />

                      </a>
                      <div className="item-shape spotlight">
                        <img src="/assets/images/item/small-comet.webp" alt="item" />
                      </div>
                    </div>
                    <div className="img-hover">
                      <img src={`/assets/images/item/${service.image}`} width="140" height="140" alt="item" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Portfolio Section */}
              <div id="portfolio" className="section-portfolio spacing-1 stack-element section">
                <div className="heading-section mb_42">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_34">
                    Portfolio
                  </div>
                  <h3 className="text_white fw-5 split-text effect-blur-fade">Featured Projects</h3>
                </div>
                <div className="tabs-content-wrap">
                  {[
                    { image: 'project-7.jpeg', tag: 'Robotics', title: 'Robocon 2025', type: 'image', link: '' },
                    { image: 'project-1.jpg', tag: 'Web Development', title: 'Krox Technology', type: 'image', link: 'https://kroxtechnologies.com/' },
                    { image: 'project-3.png', tag: 'Web Development', title: 'Dhruvi Bags', type: 'image', link: 'https://dhruvibags.web.app/login' },
                    { image: 'project4.png', tag: 'Team Falcon', title: 'Member Of Team Falcon', type: 'image', link: '' },
                    { image: 'project-5.png', tag: 'Web Development', title: 'Apex Advisor', type: 'image', link: 'https://apex-advisors.co.in/' },
                    { image: 'project-6.png', tag: 'Web Development', title: 'The Faim Gym', type: 'image', link: 'https://www.thefaimgym.com/' },
                    { image: 'project-8.png', tag: 'Web Development', title: 'Hackovate LJ 2025 | Smart AI Farmering', type: 'image', link: 'https://example.com/hackovate' },
                    { image: 'project-10.png', tag: 'Web Development', title: 'Translator WebApp', type: 'image', link: 'https://patelarsh.com/bharatranslator/' },
                    { image: 'project-11.png', tag: 'Web Development', title: 'Vatsal Group', type: 'image', link: 'https://vatsalgroup.in/' },
                    { image: 'project-12.png', tag: 'Web Development', title: 'Rudra Industries', type: 'image', link: 'https://rudraindustries.ltd/' },
                    { image: 'project-13.png', tag: 'Web Development', title: 'Milda', type: 'image', link: 'https://milda-5d603.web.app/' },
                    { image: 'project-14.png', tag: 'Web Development', title: 'Voltshire Build & Electrics', type: 'image', link: 'https://www.voltshirebuildandelectrics.co.uk/' },
                    { image: 'project-15.png', tag: 'Web Development', title: 'Ryverb', type: 'image', link: 'https://ryverb.com/' },
                    { image: 'project-2.jpeg', tag: 'App Development', title: 'Shesphere (Women Safty APP)', type: 'image', link: 'https://github.com/dhairya49/SheSphere_DevBhuva_15' },
                    { image: 'project-9.jpg', tag: 'App Development', title: 'Doctor Plant | Smart Farmering Application', type: 'image', link: 'https://github.com/madhavbhayani/Smart-Farming-App-Doctor-Plant-Daily-Market-Prices' },

                    // ✅ Video project with external link
                    // { video: 'demo.mp4', tag: 'IOT', title: 'Line follow Robot', type: 'video', link: 'https://example.com/line-follow-robot' },
                  ].map((project, index) => (
                    <div key={index} className="portfolio-item element">
                      <a
                        href={
                          project.type === 'video'
                            ? `/assets/images/user/${project.video}`
                            : `/assets/images/user/${project.image}`
                        }
                        className="img-style"
                      >
                        {project.type === 'video' ? (
                          <video
                            width="690"
                            height="388"
                            controls
                            poster="/assets/images/user/video-thumb.jpg"
                          >
                            <source src={`/assets/images/user/${project.video}`} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={`/assets/images/user/${project.image}`}
                            width="690"
                            height="388"
                            alt={project.title}
                          />

                        )}

                        <div className="tag font-3 text-label text-uppercase fw-6 letter-spacing-1">
                          {project.tag}
                        </div>
                      </a>

                      <h5 className="title font-4 text_white">
                        {/* 🔗 Use the project.link here */}
                        <a href={project.link} className="link" target="_blank" rel="noopener noreferrer">
                          {project.title}
                        </a>
                      </h5>

                      <div className="item-shape">
                        <img src="/assets/images/item/small-comet.png" alt="item" />
                      </div>
                    </div>
                  ))}
                </div>


              </div>

              {/* blog Section */}
              <div id="testimonial" className="section-testimonial section spacing-1">
                <div className="heading-section mb_43">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_30 d-flex align-items-center gap-2">
                    Blog
                    {isRefreshing && (
                      <span className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <h3 className="text_white fw-5 split-text effect-blur-fade">Latest Posts</h3>
                    <button
                      onClick={refreshBlogs}
                      className="btn btn-outline-primary btn-sm"
                      disabled={isRefreshing}
                    >
                      {isRefreshing ? 'Refreshing...' : 'Refresh'}
                    </button>
                  </div>
                </div>

                {blogs.length > 0 ? (
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation={{
                      nextEl: ".sw-single-next",
                      prevEl: ".sw-single-prev",
                    }}
                    autoplay={{
                      delay: 6000,
                      disableOnInteraction: false
                    }}
                    loop={blogs.length > 1}
                    className="sw-single"
                  >
                    {blogs.map((blog, index) => (
                      <SwiperSlide key={blog.slug}>
                        <div className="testimonial-item area-effect">
                          {blog.coverImage && (
                            <img
                              src={blog.coverImage.url}
                              alt={blog.title}
                              className="mb_21 rounded-lg w-full object-cover"
                              loading="lazy"
                            />
                          )}
                          <h5 className="name text_white mb_4 font-4">
                            <a
                              href={`https://robocon2025-journey.hashnode.dev/${blog.slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {blog.title}
                            </a>
                          </h5>
                          <p className="text-body-2 text_white mb_21">{blog.brief}</p>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="text-label text-uppercase text_primary-color font-3">
                              {new Date(blog.publishedAt).toLocaleDateString()}
                            </span>
                            {index === 0 && (
                              <span className="badge bg-primary">Latest</span>
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="text_white text-center">
                    <p>No blog posts available.</p>
                  </div>
                )}

                {blogs.length > 1 && (
                  <div className="wrap-sw-button d-flex gap_12 mt-4">
                    <div className="sw-button sw-single-prev">
                      <i className="icon-CaretLeft"></i>
                    </div>
                    <div className="sw-button sw-single-next">
                      <i className="icon-CaretRight"></i>
                    </div>
                  </div>
                )}
              </div>


              {/* Certificate */}
              {/* <div id="portfolio" className="section-portfolio spacing-1 stack-element section">
  <div className="heading-section mb_42">
    <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_34">
      Certificates
    </div>
    <h3 className="text_white fw-5 split-text effect-blur-fade">My Certifications</h3>
  </div>
  
  <div className="tabs-content-wrap">
    {[
      { image: 'robocon (1).jpg', title: 'Robocon 2025', link: '' },
      { image: 'AI.png', title: 'Generative AI: Prompt Engineering Basic', link: 'https://www.coursera.org/account/accomplishments/verify/HBKG2I12AOSR' },
      { image: 'building-ai-powered-search-with-mongodb-vector-sear.1.png', title: 'Building AI-Powered Search with MongoDB Vector Search', link: 'https://www.credly.com/badges/8f26990a-2d38-473e-a2a5-edb1610c6734/' },
      { image: 'certificate_Dev Bhuva.jpg', title: 'HACKOUT\'25 DA-IICT', link: '' },
      { image: 'cyber.jpeg', title: 'CYBER THREAT INTELLIGENCE 101', link: 'https://arcx.io/verify-certificate?id=6722b1f293082107f2bcee2e1eabfff0ccdbc340&k=bee0d64fe1be43e6b9847197e2cabd87' },
      { image: 'from-relational-model-sql-to-mongodb-s-document-mod.png', title: 'From Relational Model (SQL) to MongoDB\'s Document Model', link: 'https://www.credly.com/badges/7fa22d81-608f-4dd5-be52-b0df38cdef63/' },
      { image: 'LJ Innovation 25.jpeg', title: 'Innovation Village 2025', link: '' },
      { image: 'mentor.jpg', title: 'Mentor cum Moderator', link: '' },
      { image: 'mongodb-schema-design-patterns-and-anti-patterns-sk.png', title: 'MongoDB Schema Design Patterns and Anti-patterns Skill Badge', link: 'https://www.credly.com/badges/2b2bb18b-565a-4731-9329-5f6ce0db8454/' },
      { image: 'OdooXGVP 25.jpg', title: 'OdooXGVP 25 HAckthon', link: '' },
      { image: 'python.png', title: 'Introduction to Python ', link: 'https://www.coursera.org/account/accomplishments/verify/XWXWHZ4RGYTL' },
      { image: 'scratch.png', title: 'Programming with Scratch ', link: 'https://www.coursera.org/account/accomplishments/verify/G3EHXRR47C8Q' },
      { image: 'skill.png', title: 'Interpersonal Skill ', link: 'https://www.coursera.org/account/accomplishments/verify/CAZSM9A49K4W' },
      { image: 'TECHHACK.jpg', title: 'TECHHACK HACKATHON ', link: '' },
      { image: 'Vision.png', title: 'Vison Control by Meta ', link: 'https://www.coursera.org/account/accomplishments/verify/EEB55I0RTZFP' },
    ].map((certificate, index) => (
      <div key={index} className="portfolio-item element">
        <a
          href={certificate.link}
          className="img-style"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`/assets/images/certificate/${certificate.image}`}
            width="690"
            height="388"
            alt={certificate.title}
          />
        </a>

        <h5 className="title font-4 text_white">
          <a 
            href={certificate.link} 
            className="link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            {certificate.title}
          </a>
        </h5>

        <div className="item-shape">
          <img src="/assets/images/item/small-comet.png" alt="item" />
        </div>
      </div>
    ))}
  </div>
</div> */}
              {/* Achivemnts */}
              <div id="resume" className="section-resume spacing-1 section">
                <div className="heading-section mb_44">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_30">
                    Achivemnts
                  </div>
                  <h3 className="text_white fw-5 split-text effect-blur-fade">Certificate & Awards</h3>
                </div>
                <div className="effect-line-hover">
                  {[
                    { title: 'Menter Cum Moderator', school: 'LJ Polytechnic', date: '2023' },
                    { title: 'Software Development Enginner (SDE)', school: 'BLUESTOCK.in', date: '30 Aug' },
                    { title: 'Innovation Village 2024', school: 'LJ University', date: '2024' },
                    { title: 'Innovation Village 2025', school: 'LJ University', date: '2025' },
                    { title: 'Hackathon OdooXGVP', school: 'Odoo', date: '2025' },
                    { title: 'Robocon 2025', school: 'DD Robocon', date: '2025' },
                    { title: 'CyberSecurity & Ethical Hacking Workshop', school: 'H2 Infosec', date: '2025' },
                  ].map((item, index) => (
                    <div key={index} className="wrap-education-item area-effect scrolling-effect effectTop">
                      <span className="point"></span>
                      <div className="education-item">
                        <div className="content">
                          <h5 className="font-4 mb_4">
                            <a href="#contact" className="link">{item.title}</a>
                          </h5>
                          <span className="text-body-1 font-3">{item.school}</span>
                        </div>
                        <div className="date text-caption-1 text_white font-3">
                          {item.date}
                        </div>
                        <div className="item-shape spotlight">
                          <img src="/assets/images/item/small-comet.webp" alt="item" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>


              {/* Partners Section */}
              <div id="partners" className="section-partner section spacing-1">
                <div className="heading-section mb_44">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_32">
                    Partner
                  </div>
                  <h3 className="text_white fw-5 split-text effect-blur-fade">Trusted By 100+ Brands Worldwide</h3>
                </div>
                <div className="swiper tf-sw-partner wrap-partner">
                  <div className="swiper-wrapper">
                    {Array.from({ length: 9 }, (_, i) => (
                      <div key={i} className="swiper-slide">
                        <span className={`partner-item item-${i + 1} sz-100 scrolling-effect effectZoomIn`}>
                          <img src={`/assets/images/logo/partner-${i + 1}.png`} alt="partner" />
                          <div className="item-shape">
                            <img src="/assets/images/item/small-comet.png" alt="item" />
                          </div>
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Contact Section */}
              <div id="contact" className="section-contact spacing-1 pb-0 section">
                <div className="heading-section mb_44">
                  <div className="tag-heading text-uppercase text-label font-3 letter-spacing-1 mb_33">
                    Contact
                  </div>
                  <h3 className="text_white fw-5 animationtext clip">
                    Lets <span className="tf-text s1 cd-words-wrapper text_primary-color">
                      <span className="item-text is-visible">Design</span>
                      <span className="item-text is-hidden">Create</span>
                      <span className="item-text is-hidden">Craft</span>
                    </span> <br /> Incredible Work Together
                  </h3>
                </div>
                <form className="form-contact bs-light-mode" onSubmit={handleSubmit}>
                  <div className="heading-title d-flex justify-content-between align-items-center mb_32">
                    <div>
                      <h4 className="text_white fw-4 mb_4">
                        <a href="mailto:devbhuva1206@gmail.com" className="hover-underline-link link">
                          devbhuva1206@gmail.com
                        </a>
                      </h4>
                      <p className="text-caption-2 text_secondary-color font-3">Based in Ahmedabad, India</p>
                    </div>
                    <ul className="list-icon d-flex">
                      {/* eslint-disable jsx-a11y/anchor-has-content */}
                      <li><a href="https://www.linkedin.com/in/devbhuva" className="fab fa-linkedin" aria-label="LinkedIn"></a></li>
                      <li><a href="https://github.com/DevBhuva/" className="fab fa-github" aria-label="GitHub"></a></li>
                      <li><a href="https://x.com/DevBhuva07" className="fab fa-x" aria-label="X (Twitter)"></a></li>
                      {/* eslint-enable jsx-a11y/anchor-has-content */}
                      <li><a href="https://hashnode.com/@devbhuva" aria-label="Hashnode"><SiHashnode size={28} /> </a></li>
                    </ul>
                  </div>

                  <div>
                    {submitStatus === 'success' && (
                      <div className="alert alert-success mb_24">
                        Thank you! Your message has been sent successfully.
                      </div>
                    )}

                    {submitStatus === 'error' && (
                      <div className="alert alert-error mb_24">
                        Sorry, there was an error sending your message. Please try again.
                      </div>
                    )}

                    <form onSubmit={handleSubmit}>
                      <div className="d-grid gap_24 mb_24">
                        <fieldset>
                          <input
                            id="name"
                            type="text"
                            placeholder="Your name"
                            name="name"
                            value={formData.name}
                            onChange={handleFormChange}
                            required
                            disabled={isSubmitting}
                          />
                        </fieldset>

                        <fieldset>
                          <input
                            type="email"
                            placeholder="Your email"
                            name="email"
                            value={formData.email}
                            onChange={handleFormChange}
                            id="email"
                            required
                            disabled={isSubmitting}
                          />
                        </fieldset>

                        <fieldset>
                          <textarea
                            id="message"
                            rows="4"
                            placeholder="Your Message..."
                            name="message"
                            value={formData.message}
                            onChange={handleFormChange}
                            required
                            disabled={isSubmitting}
                          ></textarea>
                        </fieldset>
                      </div>

                      <button
                        className="tf-btn style-1 animate-hover-btn"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        <span>
                          {isSubmitting ? 'Sending...' : 'Get Started !'}
                        </span>
                      </button>
                    </form>
                  </div>
                  <div className="item-shape">
                    <img src="/assets/images/item/small-comet.webp" alt="item" />
                  </div>
                </form>
                <p className="font-3 text_secondary-color">© 2025 Dev Bhuva. All Rights Reserved.</p>
              </div>
            </div>

            {/* Footer Logo */}
            <div className="footer-logo footer-container text-center">
              <img src="/assets/images/logo/footer.png" width="755" height="295" alt="footer" />
            </div>
          </div>
        </div>

        {/* Right Bar */}
        <div className="right-bar style-1 d-flex flex-column align-items-center">
          <ul className="list-icon menu-option d-flex flex-column gap_8">
            <li>
              <button className="link-no-action show-sidebar" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <i className="fas fa-grip"></i>
              </button>
            </li>
            <li>
              <div className="toggle-switch-mode" onClick={() => setIsDarkMode(!isDarkMode)}>
                <i class="far fa-sun"></i>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Overlay */}
      <div className="overlay-popup"></div>

      {/* Popup Show Bar */}
      <div className="popup-show-bar">
        <div className="tf-container w-6">
          <div className="header-sidebar style-1">
            <div className="box">
              <div className="avatar">
                <img src="/assets/images/user/me.png" width="68" height="68" alt="avatar" />
              </div>
              <div className="info">
                <h6 className="font-4 mb_4">Dev Bhvua</h6>
                <div className="text-label text-uppercase fw-6 text_primary-color font-3 letter-spacing-1">
                  Full Stack Developer
                </div>
              </div>
            </div>
            <ul className="nav-menu style-1 llg-hide">
              {menuItems.map((item, index) => (
                <li key={index} className="text-menu text_white">
                  <a href={item.href} className="nav_link toggle splitting link link-no-action text-button font-3 fw-6">
                    <span className="text" data-splitting>{item.label}</span>
                    <span className="text" data-splitting>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
            <div className="d-flex gap_12 align-items-center">
              <a href="#contact" className="tf-btn style-1 btn-switch-text">
                <span>
                  <span className="btn-double-text" data-text="Hire Me">Hire Me</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Settings Panel */}
      {isSettingsOpen && (
        <div className="offcanvas offcanvas-bottom popup-setting" id="setting-menu">
          <div className="close-menu" onClick={() => setIsSettingsOpen(false)}>
            <i className="icon icon-times-solid"></i>
          </div>
          <div className="offcanvas-body">
            <div className="mb-body">
              <div className="inner">
                <div className="setting-color-option">
                  <div className="wrap-features">
                    <div className="feature-color tf-setting-color">
                      <h5 className="font-4 mb_29">Color</h5>
                      <div className="settings-color list-choose">
                        {Array.from({ length: 8 }, (_, i) => (
                          <button key={i} type="button" aria-label={`Color option ${i + 1}`} className={`choose-item link-no-action ${i === 0 ? 'active' : ''}`}></button>
                        ))}
                      </div>
                    </div>
                    <span className="line"></span>
                    <div className="features-background">
                      <h5 className="font-4 mb_19">Background</h5>
                      <div className="d-flex flex-wrap wrap-feature-bg-item">
                        {[
                          { image: 'feature-bg-1.webp', title: 'Glowing Digital Waves', link: 'home-v1.html' },
                          { image: 'feature-bg-2.webp', title: 'Vibrant Particle Glow', link: 'home-v2.html' },
                          { image: 'feature-bg-3.webp', title: 'Cyber Particle Waves', link: 'home-v3.html' },
                          { image: 'feature-bg-4.webp', title: 'Slow-Motion Particle Wave', link: 'home-v4.html' },
                          { image: 'feature-bg-7.webp', title: 'Futuristic Cyber Matrix', link: 'home-v7.html' },
                          { image: 'feature-bg-5.webp', title: 'Particle Wave Form', link: 'home-v5.html' },
                          { image: 'feature-bg-6.webp', title: 'Looping Particle Animation', link: 'home-v6.html' },
                          { image: 'feature-bg-8.webp', title: 'Seamless Particle Glow', link: 'home-v8.html' },
                          { image: 'feature-bg-9.webp', title: 'Digital technology', link: 'home-v9.html' },
                          { image: 'feature-bg-11.webp', title: 'Dotted waves bounce', link: 'home-v10.html' },
                          { image: 'feature-bg-10.webp', title: 'Solid Color Background', link: 'home-v11.html' }
                        ].map((bg, index) => (
                          <div key={index} className="feature-bg-item">
                            <img
                              src={`/assets/images/landing/${bg.image}`}
                              width="207"
                              height="76"
                              alt="feature-bg"
                            />
                             <a href={bg.link} target="_blank" rel="noreferrer" className="text-body-1 text_white font-3">
                              {bg.title}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}